// Shared option-list helpers for filter dropdowns.
//
// Several register surfaces build a select's options by merging a fixed enum
// reference set with the distinct values actually present in the data. This is
// the one canonical implementation they all import.

/**
 * Sorted, de-duplicated union of a fixed enum set with the values actually
 * present. Empty / falsy entries are dropped so a blank option never leaks into
 * a dropdown; the result is sorted with a numeric-aware locale comparison so
 * values like `"2"` and `"10"` order naturally.
 */
export function unionOptions(enumValues: readonly string[], present: readonly string[]): string[] {
  const seen = new Set<string>([...enumValues, ...present].filter(Boolean));
  return [...seen].sort((a, b) => a.localeCompare(b, undefined, { numeric: true }));
}
